<template>
  <header id="site-header" class="flex site-header" :class="{ open: isOpen, 'is-home': isHomeUrl }">
    <div class="content-max-width flex items-center justify-start gap-x-[30px]">
      <a href="/" class="logo">
        <img src="/images/sportsmnz-logo.svg" :alt="data.site_name" />
      </a>
      <div class="dt-left">
        <ul class="flex items-center">
          <li>
            <a href="/find-a-boat">FIND A BOAT</a>
          </li>
          <li>
            <a href="/brands">BRANDS</a>
          </li>
          <li>
            <a href="/sell-a-boat">SELL A BOAT</a>
          </li>
        </ul>
      </div>

      <div class="dt-right flex gap-x-[18px]">
        <div class="flex burger-wrap items-wrap">
          <button @click="toggleMenu">
            <img src="/images/burger-ico.png" alt="burger-ico" />
          </button>
        </div>
        <div class="country-select">
          <span class="flex items-center gap-x-4">
            <img
              @click.prevent="toggleSearch"
              ref="s-button"
              src="/images/search-ico.png"
              alt="search-ico"
              class="cursor-pointer"
            />
            <a
              href="#"
              ref="cs-button"
              @click.prevent="toggleCountrySelect"
            >
              <span class="inline-flex items-center justify-center gap-x-[1px]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="14"
                  viewBox="0 0 24 24"
                  width="14"
                  fill="currentColor"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                  />
                </svg>
                {{ (this.currentLocale).toUpperCase() }}
              </span>
            </a>
          </span>
          <div
            class="search-dropdown"
            v-show="searchOpen"
            v-closable="{
              exclude: ['s-button'],
              handler: 'searchClose',
            }"
          >
            <h3>SEARCH</h3>
            <input type="text" v-model="keyword" @keyup.enter="submitSearch" placeholder="Search...">
            <div class="flex btn-grp">
              <button class="red" @click="submitSearch">SEARCH</button>
              <button class="grey" @click.prevent="toggleSearch">CANCEL</button>
            </div>
          </div>
          <div v-show="countrySelectOpen" class="cs-bg"></div>
          <div
            v-show="countrySelectOpen"
            class="cs-dropdown-new"
            v-closable="{
            exclude: ['cs-button'],
              handler: 'countrySelectClose',
            }"
          >
          <button class="close" @click.prevent="toggleCountrySelect"></button>
            <h3>SELECT COUNTRY</h3>
            <!-- <p>{{data['select_country_description']}}</p> -->

            <div class="flex flex-wrap justify-center gap-[16px]">
              <button class="button" :class="{ outline: currentLocale != 'nz' }" @click="updateLocale('nz')">NEW ZEALAND</button>
              <button v-if="data.hide_aus == 0" class="button" :class="{ outline: currentLocale != 'au' }" @click="updateLocale('au')">AUSTRALIA</button>
            </div>
            <!-- <select name="currentLocale" id="locale" v-model="currentLocale">
              <option value="au">Australia</option>
              <option value="nz">New Zealand</option>
            </select>
            <div class="flex btn-grp">
              <button class="red" @click="updateLocale">UPDATE</button>
              <button class="grey" @click.prevent="toggleCountrySelect">CANCEL</button>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <nav>
      <div class="space-y-6">
        <div class="block md:hidden links-grp">
          <a class="block mb-3" href="/find-a-boat"><h3>FIND A BOAT</h3></a>
          <a class="block mb-3" href="/brands"><h3>BRANDS</h3></a>
          <a class="block mb-3" href="/sell-a-boat"><h3>SELL A BOAT</h3></a>
        </div>

        <div class="links-grp">
          <h3>OWNERS</h3>
          <ul class="space-y-2 top">
            <!-- <li v-for="(link, index) of nav" :key="index">
              <a :href="link.url">
                {{ link.title }}
              </a>
            </li> -->
            <li>
              <a href="/servicing">Servicing</a>
            </li>
            <li>
              <a v-if="currentLocale == 'nz'" href="/parts">Parts</a>
              <a v-else href="/parts-au">Parts</a>
            </li>
            <li>
              <a href="#" @click.prevent="$root.showFinancePopup">FINANCE</a>
            </li>
            <li>
              <a v-if="currentLocale == 'nz'" href="/warranty">Warranty</a>
              <a v-else href="/customer-care-warranty-au">Warranty</a>
            </li>
          </ul>
        </div>
        <div class="links-grp">
          <h3>SPORTS MARINE</h3>
          <ul class="space-y-2 top">
            <li>
              <a href="/about">About</a>
            </li>
          <li>
            <a href="/our-story">Our Story</a>
          </li>
            <li>
              <a href="/our-people">Our People</a>
            </li>
            <li>
              <a href="/testimonials">Testimonials</a>
            </li>
            <li>
              <a href="/sold-boats">Sold Boats</a>
            </li>
          </ul>
        </div>
        <div class="links-grp">
          <a href="/news"><h3>NEWS</h3></a>
        </div>
        <div class="links-grp">
          <a href="/careers"><h3>Careers</h3></a>
        </div>
        <div class="links-grp">
          <a href="/contact"><h3>CONTACT</h3></a>
        </div>
      </div>
      <button @click="toggleMenu">
        <img src="/images/nav-close-ico.png" alt="close-ico" />
      </button>
    </nav>
  </header>
</template>

<script>
import axios from "axios";

export default {
  props: {
    menu: Array,
    data: Object,
    selectedlocale: Object,
  },

  data: () => ({
    isOpen: false,
    countrySelectOpen: false,
    searchOpen: false,
    isHomeUrl: false,
    nav: [],
    keyword: '',
    currentLocale: 'nz',
  }),

  mounted() {
    this.nav = this.menu
    let currentUrl = window.location.pathname
    this.isHomeUrl = currentUrl.includes('/home')
    this.currentLocale = this.selectedlocale ? this.selectedlocale.locale : 'nz'

    // toggle select country if first time
    // if(!this.selectedlocale.hasSelected && this.data.hide_first_popup == 0) {
    //   this.toggleCountrySelect()
    // }
    axios.get('/get-locale')
    .then(res => {
      // console.log(res, this.data.hide_first_popup, this.selectedlocale.hasSelected)
      if(!res.data) {
        if(this.data.hide_first_popup == 0 && !this.selectedlocale.hasSelected) {
          this.toggleCountrySelect()
        }
      }else {
        this.currentLocale = res.data
      }
    })
  },

  methods: {
    updateLocale (local = 'nz') {
      this.currentLocale = local
      axios.get('/update-locale/' + this.currentLocale)
      .then(res => {
         axios.get('/get-locale')
         setTimeout(function () {
            location.reload()
          }, 100);
      })
      this.toggleCountrySelect()
      
      
    },

    toggleMenu () {
      this.isOpen = !this.isOpen
      if (this.isOpen) this.$parent.$el.className = 'nav-open'
      else this.$parent.$el.classList.remove('nav-open')
    },

    selectLocale (locale) {
      this.currentLocale = locale
      this.countrySelectOpen = false
    },

    toggleSearch () {
      this.searchOpen = !this.searchOpen
    },

    toggleCountrySelect () {
      this.countrySelectOpen = !this.countrySelectOpen
    },

    countrySelectClose () {
      this.countrySelectOpen = false
    },

    searchClose () {
      this.searchOpen = false
    },

    submitSearch () {
       window.location.href = `/find-a-boat?keyword=${this.keyword}`
    }
  },
}
</script>
